/**
 * @param hostname <feature-env>.<app>.<stage>.coin.siemens-energy.com
 * @return object of all prefixes ending with a dot, e.g. for customer app:
 * {
 *    featurePrefix: 'ecl.',
 *    appPrefix: '',
 *    stagePrefix: 'dev.'
 * }
 * */
/* eslint-disable no-useless-escape */
export function parsePrefixes(hostname: string) {
  if (hostname === 'localhost') return { featurePrefix: 'test.', appPrefix: 'test.', stagePrefix: 'test.' }; // workaround for tests which should be using local env

  const stagePrefixes = ['dev.', 'preprod.'].join('|');
  const appPrefixes = ['admin.', 'importer.', 'cosmos.'].join('|'); // no prefix for customer
  const featurePrefixes = `.+(?<!${appPrefixes.replaceAll('.', '')})\.`;

  try {
    const [, featureEnv, app, stage] = new RegExp(
      `(${featurePrefixes})?(${appPrefixes})?(${stagePrefixes})coin.siemens-energy.com`
    ).exec(hostname);

    return { featurePrefix: featureEnv ?? '', appPrefix: app ?? '', stagePrefix: stage ?? '' };
  } catch {
    throw new Error(`Could not parse prefixes: ${hostname}`);
  }
}
